import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ConditionsGenerales() {
  return (
    <main style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      <section className="bg-white pt-32 pb-8">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <span className="text-xs font-medium tracking-widest text-[#6B6B6B] uppercase">Légal</span>
          <h1 className="text-4xl lg:text-5xl font-bold text-[#0A0A0A] mt-3 leading-tight">
            Conditions générales
          </h1>
          <div className="mt-4 w-16 h-0.5 bg-[#0A0A0A]" />
          <p className="mt-4 text-sm text-[#6B6B6B]">Dernière mise à jour : mars 2026</p>
        </div>
      </section>

      <article className="bg-white py-12 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-10">

          {/* Bloc entreprise */}
          <div className="bg-[#F7F6F4] rounded-lg p-6" style={{ fontFamily: 'monospace' }}>
            <p className="text-sm text-[#0A0A0A] font-semibold">HASPICA</p>
            <p className="text-sm text-[#6B6B6B]">Patrik Haspica — Entrepreneur individuel</p>
            <p className="text-sm text-[#6B6B6B]">SIRET : 102 262 441 00011</p>
            <p className="text-sm text-[#6B6B6B]">12 Rue Judaïque, 33000 Bordeaux, France</p>
            <p className="text-sm text-[#6B6B6B]">Email : patrikhasp1ca@outlook.com</p>
            <p className="text-sm text-[#6B6B6B]">Tél : +33 6 07 32 41 93</p>
          </div>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">1. Objet</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Les présentes conditions générales régissent l'utilisation du site internet de HASPICA ainsi que les relations contractuelles entre HASPICA et ses clients dans le cadre de la fourniture de prestations de design graphique, design visuel et conception créative.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">2. Présentation du site</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Le site présente les services de design proposés par HASPICA, studio indépendant basé à Bordeaux, France. Il est destiné à informer les visiteurs des prestations disponibles et à leur permettre de prendre contact.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">3. Propriété intellectuelle</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Tous les contenus du site (textes, images, éléments graphiques, logotypes, visuels) sont protégés par le droit de la propriété intellectuelle et demeurent la propriété exclusive de HASPICA, sauf mention contraire. Toute reproduction, modification, diffusion ou exploitation, même partielle, est strictement interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">4. Responsabilité</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              HASPICA s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le site. Toutefois, HASPICA ne peut être tenu responsable d'éventuelles erreurs, omissions ou résultats obtenus à partir d'une mauvaise utilisation des informations publiées.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">5. Liens hypertextes</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Le site peut contenir des liens vers des sites tiers. HASPICA n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leurs pratiques.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">6. Droit applicable</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Les présentes conditions générales sont soumises au droit français. En cas de litige, et à défaut d'accord amiable, les tribunaux compétents de Bordeaux seront seuls compétents.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0A0A0A] mb-3">7. Contact</h2>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Pour toute question relative aux présentes conditions, vous pouvez nous contacter à l'adresse suivante :{' '}
              <a
                href="mailto:patrikhasp1ca@outlook.com"
                className="text-[#0A0A0A] underline cursor-pointer"
                rel="nofollow"
              >
                patrikhasp1ca@outlook.com
              </a>
            </p>
          </section>

        </div>
      </article>

      <Footer />
    </main>
  );
}
